var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewsIconTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000001743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.98257 20.6034H2.4931C1.4813 20.6034 0.762941 19.6175 1.07276 18.6543C1.89577 16.0954 4.41816 14.2438 7.25063 14.2438C8.60182 14.2438 9.85455 14.6651 10.8847 15.3836M10.3487 11.1304C11.5081 9.90412 13.1501 9.13897 14.9709 9.13897C16.3221 9.13897 17.5748 9.56033 18.6049 10.2788M4.2087 11.163C4.2087 9.47403 5.57794 8.10481 7.26696 8.10481C8.95598 8.10481 10.3252 9.47403 10.3252 11.163C10.3252 12.852 8.95598 14.2212 7.26696 14.2212C5.57794 14.2212 4.2087 12.852 4.2087 11.163ZM11.9289 6.05822C11.9289 4.36923 13.2982 3 14.9872 3C16.6762 3 18.0455 4.36923 18.0455 6.05822C18.0455 7.74722 16.6762 9.11644 14.9872 9.11644C13.2982 9.11644 11.9289 7.74722 11.9289 6.05822ZM12.4103 17.8648C12.4103 17.8648 14.3357 14.0141 17.7052 14.0141C21.0746 14.0141 23 17.8648 23 17.8648C23 17.8648 21.0746 21.7156 17.7052 21.7156C14.3357 21.7156 12.4103 17.8648 12.4103 17.8648ZM18.9428 17.8647C18.9428 18.5483 18.3886 19.1025 17.7051 19.1025C17.0215 19.1025 16.4673 18.5483 16.4673 17.8647C16.4673 17.1811 17.0215 16.627 17.7051 16.627C18.3886 16.627 18.9428 17.1811 18.9428 17.8647Z",
    stroke: "#A175FF",
    strokeWidth: 1.65033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIconTheme);
export default __webpack_public_path__ + "static/media/ViewsIconTheme.bd2a01a20d33acded2a3d1bd00a9c1f4.svg";
export { ForwardRef as ReactComponent };